var site = site || {};
var generic = generic || {};

(function () {
  var rpcPending = false;
  var validationRpc = null;

  function _normalizeResponseKeys(items) {
    var replaceKey = function (key) {
      return key.replace(/\./, '_');
    };
    var normalizeArray = function (array) {
      var newArray = [];

      for (var x = 0, alen = array.length; x < alen; x++) {
        var innerObj = {};

        if (typeof array[x] == 'string') {
          // When the array just has a string, just push that.
          newArray.push(array[x]);
        } else {
          // When the array is anything else, just push that.
          for (var innerKey in array[x]) {
            innerObj[replaceKey(innerKey)] = array[x][innerKey];
          }
          newArray.push(innerObj);
        }
      }

      return newArray;
    };
    var out = [];

    for (var i = 0, len = items.length; i < len; i++) {
      out[i] = {};
      for (var key in items[i]) {
        if (items[i].hasOwnProperty(key)) {
          // Need to go deeper for collection items.
          if ($.isArray(items[i][key])) {
            out[i][replaceKey(key)] = normalizeArray(items[i][key]);
          } else {
            out[i][replaceKey(key)] = items[i][key];
          }
        }
      }
    }

    return out;
  }

  $(document).on('one_click_overlay:oneclickValidation', '.js-one-click-btn', function () {
    Drupal.behaviors.buyWithOneClickOverlay.oneclickValidation();
  });

  Drupal.behaviors.buyWithOneClickOverlay = {
    attach: function (context) {
      var self = this;
      var $oneClick = $('.js-one-click-btn', context);
      var $buyNowBtn = $('.js-buy-now-btn', $oneClick);

      $buyNowBtn.once().on('click', function (e) {
        e.preventDefault();
        if ($(this).data('disabled')) {
          return null;
        }
        var skuBaseId = !$(this).data('kit-skus')
          ? $('.js-product-full-v2', context).attr('data-sku-base-id')
          : $(this).data('kit-skus');
        var args = {};

        if (skuBaseId.indexOf(',') >= 0) {
          args.SKU_BASE_ID = skuBaseId.split(',');
          if (skuBaseId.slice(-1) === ',') {
            args.SKU_BASE_ID.pop();
          }
        } else {
          args.SKU_BASE_ID = [skuBaseId];
        }
        args.from = 2;
        self.showBuyWithOneClickOverlay(args);
      });
    },
    oneclickValidation: function () {
      // this fires multiple times by inventory_status_v2.js & product_replenishment_select_v2.js
      var data = {};
      var $replenishFreq = $('.js-replenishment-select');
      var replenishFreqValue = $replenishFreq ? $replenishFreq.val() : '';

      // make sure we are only firing the rpc call the first time
      if (validationRpc !== null || !site.userInfoCookie.getValue('signed_in')) {
        // run a "cached" version from our last onceClick.validation rpc call
        if (validationRpc === 1 && !replenishFreqValue) {
          Drupal.behaviors.buyWithOneClickOverlay.showOneclickBtn();
        } else {
          // don't show the button, you are not logged in or not supposed to see it
          Drupal.behaviors.buyWithOneClickOverlay.hideOneclickBtn();
        }

        return false;
      } else if (rpcPending) {
        // this happens when the rpc is still pending
        return false;
      }

      rpcPending = true;

      generic.jsonrpc.fetch({
        method: 'oneClick.validation',
        params: [data],
        onSuccess: function (jsonRpcResponse) {
          if (jsonRpcResponse && jsonRpcResponse.getValue) {
            if (jsonRpcResponse.getValue() === 1) {
              Drupal.behaviors.buyWithOneClickOverlay.showOneclickBtn();
              validationRpc = 1;
            }
          }
        },
        onFailure: function () {
          Drupal.behaviors.buyWithOneClickOverlay.hideOneclickBtn();
          validationRpc = 0;
        }
      });
    },
    showOneclickBtn: function () {
      // Show the oneClick button
      var $oneClick = $('.js-one-click-btn');
      var $buyNowBtn = $('.js-buy-now-btn', $oneClick);
      var isMobile = Unison.fetch.now().name === 'small';
      var isDisabled = $('.js-product-cta', '.js-product-full-bag-btn').hasClass('button--disabled');
      var isKitDisabled = $('.js-kit-add-to-cart', '.js-product-starter-kit-ctas-shaded-wrapper').hasClass('button--disabled');

      $oneClick.removeClass('hidden');
      $buyNowBtn.removeClass('hidden').removeClass('button--disabled');
      $buyNowBtn.data('disabled', false);
      $(
        '.js-product-full-ctas-non-shaded-wrapper, .js-product-starter-kit-ctas-non-shaded-wrapper'
      ).addClass('one-click-non-shaded-wrapper');
      $(
        '.js-product-full-ctas-shaded-wrapper, .js-product-starter-kit-ctas-shaded-wrapper'
      ).addClass('one-click-shaded-wrapper');
      $('.js-sticky-add-to-bag-container').addClass('sticky-one-click-wrapper');

      if (isDisabled || isKitDisabled) {
        $buyNowBtn.addClass('button--disabled');
        $buyNowBtn.data('disabled', true);
        // tried to fire events from product_ui & inventory_status to set this instead of depending on a class...
      }
    },
    hideOneclickBtn: function () {
      // Hide the oneClick button -- you did not meet the requirements
      var $oneClick = $('.js-one-click-btn');
      var $buyNowBtn = $('.js-buy-now-btn', $oneClick);

      $buyNowBtn.addClass('hidden');
      $(
        '.js-product-full-ctas-non-shaded-wrapper, .js-product-starter-kit-ctas-non-shaded-wrapper'
      ).removeClass('one-click-non-shaded-wrapper');
      $(
        '.js-product-full-ctas-shaded-wrapper, .js-product-starter-kit-ctas-shaded-wrapper'
      ).removeClass('one-click-shaded-wrapper');
      $('.js-sticky-add-to-bag-container').removeClass('sticky-one-click-wrapper');
    },
    showBuyWithOneClickOverlay: function (args) {
      var isMobile = Unison.fetch.now().name === 'small';
      var maxWidth = isMobile ? '420px' : '560px';
      var maxHeight = isMobile ? '660px' : '560px';
      var templateData = {
        items: [],
        address: []
      };
      var oneClickErrors = [
        'user_not_signed_in.oneclick',
        'default_payment_not_found.oneclick',
        'default_shipping_not_found.oneclick',
        'not_allowed.hazmat.address',
        'no_details_found.oneclick',
        'default_payment_expired_or_not_found.oneclick',
        'payment_issue.oneclick',
        'cart.item_limit',
        'not_allowed.hazmat.address.military',
        'cart.empty',
        'cart.trans_limit'
      ];
      // Get Template html
      var buyWithOneClickOverlayContent = site.template.get({
        name: 'buy_with_one_click_overlay',
        data: { loading: true }
      });

      generic.overlay.launch({
        html: buyWithOneClickOverlayContent,
        className: 'buy-with-one-click-overlay__colorbox',
        maxWidth: maxWidth,
        maxHeight: maxHeight,
        includeCloseLink: true,
        onComplete: function () {
          $('#cboxClose').focus();
        }
      });
      generic.jsonrpc.fetch({
        method: 'oneClick.details',
        params: [args],
        onSuccess: function (d) {
          var rpcResponse = d.getValue();

          if (typeof rpcResponse === 'undefined' || !rpcResponse) {
            return;
          }
          var cartItems = rpcResponse.order.items.concat(rpcResponse.order.samples);
          var itemsData = _normalizeResponseKeys(cartItems);
          var eddData = rpcResponse.order.getEDD ? rpcResponse.order.getEDD[0].text : '';

          if (eddData) {
            eddData = eddData.replace('Est. Arrival', 'Arriving').replace(/[()]/g, '');
          }
          var paymentData = _normalizeResponseKeys(rpcResponse.trans.payments.CREDITCARDS);
          var paymentStr = '';

          if (paymentData) {
            var cardNum = paymentData[0].creditCard_displayCardNum;

            cardNum = cardNum.substr(-4);
            var cardType = paymentData[0].creditCard_CARD_TYPE;

            paymentStr = cardType + ' *' + cardNum;
          }
          var totalItemsPrice = rpcResponse.trans
            ? rpcResponse.trans['formatted.TOTAL_ITEMS_BASE_PRICE']
            : '';
          var itemsDiscAmt =
            rpcResponse.trans && rpcResponse.trans.TOTAL_ITEMS_DISCOUNT
              ? rpcResponse.trans['formatted.TOTAL_ITEMS_DISCOUNT']
              : '';
          var shippingPrice =
            rpcResponse.trans && rpcResponse.trans['TOTAL_SHIPPING_APPLIED_PRICE']
              ? rpcResponse.trans['formatted.TOTAL_SHIPPING_APPLIED_PRICE']
              : 'Free';
          var tax = rpcResponse.trans ? rpcResponse.trans['formatted.TOTAL_APPLIED_TAX'] : '';
          var total = rpcResponse.trans ? rpcResponse.trans['formatted.TOTAL_COST'] : '';
          var itemsCnt = rpcResponse.trans_items_count ? rpcResponse.trans_items_count : 0;
          var loyaltyPoints =
            rpcResponse.is_loyalty_member &&
            rpcResponse.trans &&
            rpcResponse.trans.checkHasOrderItems &&
            rpcResponse.trans.loyaltyPoints
              ? rpcResponse.trans.loyaltyPoints
              : '';
          var hideShipAddr =
            rpcResponse.order && rpcResponse.order.electronicDeliveryItemsOnly ? 1 : 0;

          templateData = {
            items: itemsData,
            address: rpcResponse.order.address
          };
          // Get Template html
          var buyWithOneClickOverlayContent = site.template.get({
            name: 'buy_with_one_click_overlay',
            data: templateData
          });

          generic.overlay.launch({
            html: buyWithOneClickOverlayContent,
            className: 'buy-with-one-click-overlay__colorbox',
            maxWidth: maxWidth,
            maxHeight: maxHeight,
            includeCloseLink: true,
            onComplete: function () {
              $('#cboxClose').focus();
            }
          });

          // To update bag icon count
          $('.site-utils__item--cart .js-cart_count').html(itemsCnt);

          // To add the class if items are more than 1
          if (cartItems && cartItems.length > 1) {
            $('.js-product-info-wrapper').addClass('more-item');
          }

          // To add the class if the product is temporarily out of stock
          if (
            cartItems &&
            cartItems.length < 2 &&
            $('.js-product-info-name-size div.error').hasClass('product-info__out-of-stock')
          ) {
            $('.js-product-info-wrapper').addClass('out-of-stock--error');
          }

          if (hideShipAddr) {
            $('.js-shipping-wrapper').addClass('hidden');
            $('.js-payment-wrapper').addClass('donation-item');
          }

          $('.js-estimated-delivery').html(eddData);
          $('.js-ship-method').html(rpcResponse.order.shipMethodName);
          $('.js-payment-details').html(paymentStr);
          $('.js-total-price').html(totalItemsPrice);

          $('.js-discount-text').addClass('hidden');
          $('.js-discount-value').addClass('hidden');
          if (itemsDiscAmt) {
            $('.js-discount-text').removeClass('hidden');
            $('.js-discount-value').removeClass('hidden');
            $('.js-discount-value').html(itemsDiscAmt);
          }

          $('.js-shipping-price').html(shippingPrice);
          $('.js-tax-value').html(tax);
          $('.js-total-value').html(total);
          $('.js-items-cnt').html(itemsCnt);

          if (itemsCnt < 2) {
            var itemsTxt = $('.total-items-text').html() ? $('.total-items-text').html() : '';
            var totalItemsTxt = itemsTxt.slice(0, -1);

            $('.total-items-text').html(totalItemsTxt);
          }

          $('.js-loyalty-section').addClass('hidden');
          if (loyaltyPoints) {
            $('.js-loyalty-section').removeClass('hidden');
            var loyaltyData = $('.js-loyalty-points').html() ? $('.js-loyalty-points').html() : '';
            var loyaltyDataRes = loyaltyData.replace('::LOYALTY_POINTS::', loyaltyPoints);

            $('.js-loyalty-points').html(loyaltyDataRes);
          }
          $('.js-place-order-btn').on('click', function (e) {
            e.preventDefault();
            generic.jsonrpc.fetch({
              method: 'oneClick.completeOrder',
              params: [args],
              onSuccess: function (jsonRpcResponse) {
                if (jsonRpcResponse.getValue()) {
                  window.location.href = '/checkout/confirm.tmpl?TID=' + jsonRpcResponse.getValue();
                }
              },
              onFailure: function (jsonRpcResponse) {
                var messages = jsonRpcResponse.getMessages();

                $('.js-one-click-popup-error-messages').html('');
                if (messages) {
                  $.each(messages, function (index) {
                    if (messages[index].key !== 'no_details_found.oneclick') {
                      $('.js-one-click-popup').addClass('hidden');
                      $('.js-one-click-popup-error-messages').append(
                        '<p>' + messages[index].text + '</p>'
                      );

                      return;
                    }
                  });
                }
              }
            });
          });
        },
        onFailure: function (jsonRpcResponse) {
          var messages = jsonRpcResponse.getMessages();
          var errArr = {};
          messages = messages || [];
          $('.js-one-click-popup-error-messages').html('');
          if (messages && messages.length > 0) {
            $.each(messages, function (index) {
              if ($.inArray(messages[index].key, oneClickErrors) !== -1) {
                errArr[messages[index].key] = messages[index].text;
              }
            });
            if ($.isEmptyObject(errArr)) {
              return true;
            } else if (errArr.hasOwnProperty('no_details_found.oneclick') && Object.keys(errArr).length === 1) {
              $('.js-one-click-popup-loading').addClass('hidden');
              $('.js-one-click-popup-error-messages').append('<span>' + errArr['no_details_found.oneclick'] + '</span>');
              return;
            } else {
              $.each(errArr, function (index, value) {
                delete errArr['no_details_found.oneclick'];
                $('.js-one-click-popup-loading').addClass('hidden');
                $('.js-one-click-popup-error-messages').append('<span>' + value + '</span>');
                return;
              });
            }
          }
        }
      });
    },
    attached: false
  };
})(jQuery);
